import styled from "styled-components";
import { MdKeyboardArrowRight, MdArrowForward } from "react-icons/md";

export const HeroContainer = styled.div`
  background: #0c0c0c;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 30px;
  height: 100vh;
  position: relative;
  z-index: 1;
  overflow-x: hidden; /* ✅ prevent horizontal overflow */

  :before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: linear-gradient(
        180deg,
        rgba(0, 0, 0, 0.2) 0%,
        rgba(0, 0, 0, 0.6) 100%
      ),
      linear-gradient(180deg, rgba(0, 0, 0, 0.2) 0%, transparent 100%);
    z-index: 2;
  }
`;

export const HeroBg = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

export const VideoBg = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover; /* ✅ no need for --o-object-fit */
  background: #232a34;
  opacity: 0.5;
  display: block; /* ✅ prevents inline video from adding extra space */
`;

export const HeroContent = styled.div`
  z-index: 3;
  max-width: 1200px;
  position: relative; /* ✅ absolute can cause overflow on small screens */
  padding: 8px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center; /* ✅ keep content centered on mobile */

  @media screen and (max-width: 768px) {
    padding: 8px 16px; /* ✅ shrink padding for mobile */
    max-width: 100%;
  }
`;

export const HeroBtnWrapper = styled.div`
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ArrowForward = styled(MdArrowForward)`
  margin-left: 8px;
  font-size: 20px;
`;

export const ArrowRight = styled(MdKeyboardArrowRight)`
  margin-left: 8px;
  font-size: 20px;
`;
